import ChallengeCreate from './ChallengeCreate';

export default {
    edit: ChallengeCreate,
    options: {
        label: "Challenges"
    }
};
